export const SITE_URL = "https://tivi-one1.com";

/** BreadcrumbList schema from the same items array the visual <Breadcrumbs> renders. */
export function buildBreadcrumbJsonLd(items) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      item: `${SITE_URL}${item.to}`,
    })),
  };
}

/** FAQPage schema — pass the exact same items rendered on the page, never invented ones. */
export function buildFaqJsonLd(items) {
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}

export function buildWebPageJsonLd({ path, name, description }) {
  return {
    "@type": "WebPage",
    "@id": `${SITE_URL}${path}#webpage`,
    url: `${SITE_URL}${path}`,
    name,
    description,
    inLanguage: "nl-NL",
    isPartOf: { "@id": `${SITE_URL}/#website` },
  };
}

/** HowTo schema for installation/setup guides. */
export function buildHowToJsonLd({ name, description, steps }) {
  return {
    "@type": "HowTo",
    name,
    description,
    step: steps.map((s, i) => ({
      "@type": "HowToStep",
      position: i + 1,
      name: s.title,
      text: s.text,
    })),
  };
}

/** Wraps one or more schema objects into a single JSON-LD @graph. */
export function graph(...schemas) {
  return { "@context": "https://schema.org", "@graph": schemas.filter(Boolean) };
}
